module.exports = __webpack_public_path__ + "static/scale-model-of-the-tech-interactive-in-san-jose-california-2546838a4cc2c592f09841c8ef694445.png";